import type { SVGProps } from 'react';

const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m13.29 19.29 6-6c.57-.57.88-1.32.88-2.12V6c0-1.65-1.35-3-3-3H12c-.8 0-1.55.31-2.12.88l-6 6A3 3 0 0 0 3 12c0 .77.29 1.54.88 2.12l5.17 5.17c.57.57 1.32.88 2.12.88s1.55-.31 2.12-.88m-2.83-1.41-5.17-5.17a.996.996 0 0 1 0-1.41l6-6a1 1 0 0 1 .71-.29h5.17c.55 0 1 .45 1 1v5.17c0 .26-.11.52-.29.71l-6 6a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29z"
    />
    <path
      fill="currentcolor"
      d="M13.17 8.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
    />
  </svg>
);
export default SvgTag;
